import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.7166 2.25835C14.7034 3.94183 17.2211 5.0297 19.9875 5.24527C20.5635 5.28972 21 5.77643 21 6.34758V11.1591C21 16.0117 17.4495 20.5599 12.5884 21.92C12.207 22.0267 11.7941 22.0267 11.4128 21.92C6.5505 20.561 3 16.0106 3 11.158V6.34647C3 5.77643 3.4365 5.28972 4.0125 5.24527C6.77888 5.0297 9.29662 3.94072 11.2834 2.25835C11.6895 1.91388 12.3094 1.91388 12.7166 2.25835ZM15.8493 10.8723C16.1422 10.5794 16.1422 10.1045 15.8493 9.81165C15.5564 9.51876 15.0816 9.51876 14.7887 9.81165L11.171 13.4293L9.21234 11.4706C8.91944 11.1778 8.44457 11.1778 8.15168 11.4706C7.85878 11.7635 7.85878 12.2384 8.15168 12.5313L10.6407 15.0203C10.7813 15.161 10.9721 15.24 11.171 15.24C11.3699 15.24 11.5607 15.161 11.7013 15.0203L15.8493 10.8723Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgShieldFilled);
export default ForwardRef;
